import Edit from "./Edit";
import New from "./New";

export default {
  Edit,
  New
};
